module.exports = __webpack_public_path__ + "static/media/MensWatch.bc910a58.webp";